import { render } from "./MarchSpeed.vue?vue&type=template&id=3da141cb&scoped=true"
import script from "./MarchSpeed.vue?vue&type=script&lang=js"
export * from "./MarchSpeed.vue?vue&type=script&lang=js"

import "./MarchSpeed.vue?vue&type=style&index=0&id=3da141cb&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3da141cb"

export default script